export default {
    state: {
        saleId: null
    }
}


// WEBPACK FOOTER //
// ./src/store/fitnes/modules/payment.js